import { render, staticRenderFns } from "./MalattieInfettiveConfigurazioneUosdModalEdit.vue?vue&type=template&id=64d32529"
import script from "./MalattieInfettiveConfigurazioneUosdModalEdit.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveConfigurazioneUosdModalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports